import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=05c51a56&scoped=true"
import script from "./ModalItem.vue?vue&type=script&lang=js"
export * from "./ModalItem.vue?vue&type=script&lang=js"
import style0 from "./ModalItem.vue?vue&type=style&index=0&id=05c51a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c51a56",
  null
  
)

export default component.exports